<template>
  <div class="r-sub-account">
    <div
      class="account-top common-flex common-justify-between common-align-center"
    >
      <div class="name">{{config.username}}</div>
      <i-switch v-model="config.status" @on-change="change" />
    </div>
    <div class="common-flex circle">
      <i-Circle :percent="(config.usableAmount/config.totalAmount)*100" stroke-linecap="square" :size="88" :trail-width="18" :stroke-width="18" :stroke-color="stroke"> </i-Circle>
      <div class="all-price common-flex common-justify-center common-direction-column">
        <div style="margin-bottom:12px"><span>{{$t('customer.totalAmount')}}:</span> {{config.totalAmount}}</div>
        <div><span>{{$t('customer.amountUsed')}}:</span>{{config.usableAmount}}</div>
      </div>
    </div>
    <div class="options common-flex common-flex-end">
        <div class="common-hover" @click="edit"> <span class="iconfont iconbianji"></span> {{$t('customer.edit')}}</div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: "r-sub-account",
  data() {
    return {
      switchs: false,
      stroke:'#1784E8'
    };
  },
  props:{
    config:Object
  },
  methods: {
    ...mapActions([
      'updateMemberStatusAction',//开启禁用账户
    ]),
    
    // updateMemberStatus(){
      
    // },
    // 开启子账号
    change() {
      // config.status
      this.updateMemberStatusAction({
        username:this.config.username,
        status:this.config.status
      }).then(res=>{
      this.$emit('update')
        
      }).catch(res=>{
        this.config.status = !this.config.status
      })
    },
    // 编辑
    edit(){
      this.$emit('edit',this.config)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-sub-account {
  width: 325px;
  height: 219px;
  border: 1px solid rgba(8, 25, 56, 0.2);
  padding: 20px 20px 14px;
  margin: 0 10px 18px;
  .account-top {
    margin-bottom: 27px;
  }
  .options{
      font-size: 12px;
      margin-top: 14px;
      color: rgba(8,25,56,.7);
  }
  .iconbianji{
      font-size: 10px;
  }
  .name {
    font-size: 14px;
    font-weight: 700;
    text-align: left;
    color: #081938;
    line-height: 16px;
  }
  .circle{
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(8,25,56,0.1);
  }
  .all-price{
      margin-left: 30px;
      >div{
          font-size: 14px;
          color: #081938;
          font-size: 400;
          span{
              color: rgba(8,25,56,0.4);
              font-size: 12px;
              margin-right: 8px;
          }
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-sub-account.vue